import { useOAuth } from './useOAuth'

interface WechatAuthOptions {
  appId?: string
}

const useWechatAuth = (options: WechatAuthOptions = {}) => {
  const { authCode, authLoading } = useOAuth({
    platform: 'wechat',
    appId: options.appId,
  })

  return {
    wechatAuthCode: authCode,
    wechatAuthLoading: authLoading,
  }
}

export default useWechatAuth
